/**
 * イベント管理
 *
 * @example
 * import Events from 'common/Events'
 *
 * Events.on('hoge', func)
 * Events.emit('hoge', 'huga')
 */
import { EventEmitter } from 'events'

export default new EventEmitter()
